(function( $ ) {
    // IP lookup, only if we have region based items...
    $.ajaxSetup({ cache: false });
    if ($('.showEU, .showUS').length >= 1) {
        $.getJSON('/wp-content/plugins/haus-evoko-extras/apiip.php', function(data) {
            console.log(data);
            if (data['geoplugin_continentCode'] == 'EU') {
                // Europe, showEU unless Turkey
                if (data['geoplugin_countryCode'] == 'TR') {
                    $('body').addClass('showUS');
                } else {
                    $('body').addClass('showEU');
                }
            } else {
                $('body').addClass('showUS');
            }
        });
    }
})(jQuery);